import React from 'react';

export const WelcomeScreen: React.FC = () => (
  <div className="flex flex-col items-center justify-center flex-1 px-8 pb-24 pt-12 text-center">
    <img
      src="/cintia.png"
      alt="CINTIA"
      className="w-48 h-auto object-contain mb-6"
      onError={(e) => {
        (e.currentTarget as HTMLImageElement).style.display = 'none';
      }}
    />
    <h1 className="text-navy font-bold text-xl">Hello, I'm CINTIA.</h1>
    <h2 className="text-navy font-semibold text-base mt-1">Welcome to CI&T at 11th Annual Becker's IT + Revenue Cycle Conference</h2>
    <p className="text-navy-64 text-sm mt-3 leading-relaxed max-w-xs">
      I know the full 11th Annual Becker's IT + Revenue Cycle Conference agenda and our healthcare case library. Ask me anything, or let me get you set up first. What should I call you?
    </p>
  </div>
);
